// extracted by mini-css-extract-plugin
module.exports = {"labelCentered":"Approve_labelCentered__1CJk9"};